import { PageController } from '@client/components/_core/layout/PageController';
import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

/** CUR-2672 (PAY-F3): Add contact from the Add payment drawer's payee list: today's new contact form. */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/payments/add/contacts/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New contact',
        },
    },
    validateSearch: zodValidator(
        z.object({
            type: fallback(z.enum(['POLICY_HOLDER', 'THIRD_PARTY', 'DRIVER']), 'THIRD_PARTY'),
        }),
    ),
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { type } = Route.useSearch();
    return (
        <PageController route={Route}>
            <ContactEdit action={['add']} type={type} entity="claim" entityId={id} />
        </PageController>
    );
}
